import type { IMainPageVersion } from '@/api/endpoints/mainPages';
import { ROUTES } from '@/shared/consts';

export const getBlocksData = (pageVersionData: IMainPageVersion) => {
  const {
    blocks_visibility: {
      about_school: isAboutSchoolVisible,
      advantages: areAdvantagesVisible,
      reviews: areReviewsVisible,
      about_bank: isAboutBankVisible,
      faqs: areFAQsVisible,
      contact: isContactVisible,
    },
    blocks_completion: {
      about_school: isAboutSchoolFilled,
      advantages: areAdvantagesFilled,
      reviews: areReviewsFilled,
      about_bank: isAboutBankFilled,
      faqs: areFAQsFilled,
      contact: isContactFilled,
    },
  } = pageVersionData;

  return [
    {
      id: 1,
      name: 'О школе',
      slug: ROUTES.MAIN_ABOUT_SCHOOL,
      required: true,
      visible: isAboutSchoolVisible,
      filled: isAboutSchoolFilled,
      fieldName: 'aboutSchool',
    },
    {
      id: 2,
      name: 'Преимущества школы',
      slug: ROUTES.MAIN_ADVANTAGES,
      required: true,
      visible: areAdvantagesVisible,
      filled: areAdvantagesFilled,
      fieldName: 'advantages',
    },
    {
      id: 3,
      name: 'Отзывы студентов',
      slug: ROUTES.MAIN_REVIEWS,
      required: false,
      visible: areReviewsVisible,
      filled: areReviewsFilled,
      fieldName: 'reviews',
    },
    {
      id: 4,
      name: 'О ПСБ',
      slug: ROUTES.MAIN_ABOUT_BANK,
      required: false,
      visible: isAboutBankVisible,
      filled: isAboutBankFilled,
      fieldName: 'aboutBank',
    },
    {
      id: 5,
      name: 'FAQ',
      slug: ROUTES.MAIN_FAQS,
      required: false,
      visible: areFAQsVisible,
      filled: areFAQsFilled,
      fieldName: 'faqs',
    },
    {
      id: 6,
      name: 'Контакты',
      slug: ROUTES.MAIN_CONTACT,
      required: false,
      visible: isContactVisible,
      filled: isContactFilled,
      fieldName: 'contact',
    },
  ];
};
